/**
 * Constants shared between server and client code paths for the admin
 * impersonation flow. No imports from `next/headers` so this can be
 * imported by both server components and client components / services.
 *
 * Server-only helpers (cookie reads via next/headers) live in
 * `apps/web/src/lib/impersonation.server.ts`.
 */

/**
 * Cookie name carrying the admin's active impersonation bearer token
 * (the raw `wmi_<base64>` value returned by POST /admin/impersonate).
 */
export const IMPERSONATION_COOKIE = 'wmi_token'

/** Token prefix used by the API to distinguish from Supabase JWTs. */
export const IMPERSONATION_TOKEN_PREFIX = 'wmi_'
